<template>
  <div id="app" v-if="!loading">
    <router-view/>
  </div>
  <div class="fullscreen loading" v-else>
    <font-awesome-icon :icon="faCircleNotch" class="beast-spinner" spin/>
  </div>
</template>

<style lang="scss">
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100%;
  }

  .fullscreen {
    width: 100%;
    padding: 0;
    margin: 0;
    line-height: calc(100vh - 50px);
    text-align: center;
    font-size: 100px;
    vertical-align: middle;
  }
</style>
<script>
import { faCircleNotch } from "@fortawesome/free-solid-svg-icons";

export default {
  computed: {
    faCircleNotch() {
      return faCircleNotch;
    }
  },
  data() {
    return {
      loading: true
    };
  },
  async beforeMount() {
    try {
      const response = await this.axios.get("/config");

      Object.assign(this.$beast.config, response.data);
      this.loading = false;
    } catch (error) {
      // nop
    }
  }
};
</script>
